export const ICONS = {
  project: 'mdi mdi-animation-outline',
  label: 'mdi mdi-label-multiple-outline',
  priority: 'mdi mdi-flag-outline',
};
